import { Api } from "./api";

export const GoogleMapsApi = {
  fromAddress: (address) => Api.get(`/google/place/autocomplete?address=${address}`, { headers: {'Authorization': sessionStorage.getItem('token')} })
}
